// @flow
import * as React from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

import AuthService from "services/auth";

function PrivateRoute(): React.Node {
  const location = useLocation();

  if (AuthService.isAuthenticated() !== true) {
    return <Navigate replace to="/login" state={{ from: location }} />;
  }

  return <Outlet />;
}

export default PrivateRoute;
